import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {AppStatusService} from './app-status.service';
import {HttpService} from './http.service';
import {NavigatorService} from './navigator.service';
import {SettingsService} from './settings.service';
import {TranslationService} from '../../shared/services/translation.service';
import { AppStatus, getCurrency } from "../@models/app-status";
import { Currency } from "../../shared-gen/Model/Utils/Currency";

/**
 * Convenience service that includes all other services of this app.
 * Can be used fort shortening constructor injections when many services are needed.
 */
@Injectable({
	providedIn: 'root'
})
export class AppService {

	constructor(public api: ApiService,
				public status: AppStatusService,
				public http: HttpService,
				public nav: NavigatorService,
				public settings: SettingsService,
				public translation: TranslationService) {
	}

	getStatus(): AppStatus {
		return this.status.appStatus.getValue();
	}

	getCurrency(): Currency {
		return getCurrency(this.getStatus());
	}

}
